<div
    class="bg-white p-3 pb-2 shadow-md dark:border dark:border-solid dark:border-contrast-yellow md:p-4"
    #cardElement
    [style.scroll-margin-top]="env.IS_MOBILE_APP ? '0' : '4rem'">
    <!-- MOBILE VIEW -->
    <div class="md:hidden">
        <div class="flex-justify-between flex-align-center flex">
            <ng-container *ngTemplateOutlet="cardHeader"></ng-container>
            <ng-container *ngTemplateOutlet="threeDotMenuMobile"></ng-container>
        </div>

        <ng-container *ngTemplateOutlet="separator"></ng-container>

        <div class="flex-justify-between flex-align-center flex flex-wrap">
            <ng-container *ngTemplateOutlet="moneyEditButton"></ng-container>
            <ng-container *ngTemplateOutlet="cardBalance"></ng-container>
        </div>

        <ng-container *ngTemplateOutlet="separator"></ng-container>

        <div class="flex-justify-center flex">
            <ng-container *ngTemplateOutlet="cardDetailsButton"></ng-container>
        </div>
    </div>

    <!-- DESKTOP VIEW -->
    <div class="hidden md:block">
        <div class="flex-justify-between flex-align-center flex">
            <ng-container *ngTemplateOutlet="cardHeader"></ng-container>
            <ng-container *ngTemplateOutlet="cardBalance"></ng-container>
        </div>

        <ng-container *ngTemplateOutlet="separator"></ng-container>

        <div class="flex-justify-between flex-align-center flex">
            <ng-container *ngTemplateOutlet="cardDetailsButton"></ng-container>
            <div class="flex-justify-between flex-align-center flex">
                <ng-container *ngTemplateOutlet="moneyEditButton"></ng-container>
                <ng-container *ngTemplateOutlet="threeDotMenuDesktop"></ng-container>
            </div>
        </div>
    </div>
</div>

<ng-template #cardHeader>
    <div
        class="flex cursor-pointer gap-3"
        [ngClass]="{ 'opacity-70 dark:opacity-100': card?.blocked }"
        (click)="navigateToDetailsView()">
        <div class="flex h-14 w-24 items-center justify-center">
            <img
                class="max-h-full max-w-full dark:filter-yellow"
                alt="Card image"
                src="{{ assetsPath$ | async }}/img/cards/{{ card?.scheme ?? 'card-template' }}.png" />
        </div>
        <div class="flex min-w-0 flex-1 flex-col justify-center gap-1">
            <h1 class="whitespace-normal break-all pr-1 text-base font-bold">
                {{ card?.name ?? card?.scheme ?? card?.cardNumber }}
            </h1>
            <span
                class="text-xs font-medium text-grey-zambezy dark:text-contrast-yellow"
                [ngClass]="{
                    hidden: card?.cardNumber === (card?.name ?? card?.scheme ?? card?.cardNumber)
                }">
                {{ card?.cardNumber }}
            </span>
            <ng-container *ngIf="env.ACCOUNT.SHOW_TRAVEL_CARD_PERSONALIZATION_STATUS">
                <span
                    class="text-xs font-medium text-grey-zambezy dark:text-contrast-yellow"
                    *ngIf="card.personalizationStatus === personalizationStatus.OTHER"
                    >{{ 'PERSONALIZE_TRAVEL_CARD_PERSONALIZATION_STATUS_OTHER' | translate }}</span
                >
                <span
                    class="text-xs font-medium text-grey-zambezy dark:text-contrast-yellow"
                    *ngIf="card.personalizationStatus === personalizationStatus.OWNER"
                    >{{ 'PERSONALIZE_TRAVEL_CARD_PERSONALIZATION_STATUS_OWNER' | translate }}</span
                >
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #threeDotMenuDesktop>
    <ion-button
        [attr.aria-label]="'THREE_DOT_MENU' | translate"
        [id]="'desktop-contextual-menu-button-' + card?.id"
        fill="clear">
        <ion-icon
            class="tartu-light-dark:text-secondary dark:filter-yellow"
            [attr.aria-label]="'THREE_DOT_MENU' | translate"
            title="{{ 'THREE_DOT_MENU' | translate }}"
            src="{{ assetsPath$ | async }}/img/cards/three-dot-menu.svg"></ion-icon>
    </ion-button>
</ng-template>

<ng-template #threeDotMenuMobile>
    <ion-button
        [attr.aria-label]="'THREE_DOT_MENU' | translate"
        [id]="'mobile-contextual-menu-button-' + card?.id"
        (click)="scrollToCard(cardElement)"
        fill="clear">
        <ion-icon
            class="tartu-light-dark:text-secondary dark:filter-yellow"
            [attr.aria-label]="'THREE_DOT_MENU' | translate"
            title="{{ 'THREE_DOT_MENU' | translate }}"
            src="{{ assetsPath$ | async }}/img/cards/three-dot-menu.svg"></ion-icon>
    </ion-button>
</ng-template>

<ng-template #moneyEditButton>
    <ion-button
        class="top-up-button h-12"
        *ngIf="isWebPurchaseAllowed && card?.cardType !== cardType.EMV"
        [disabled]="card?.blocked"
        [attr.aria-label]="'TOP_UP'"
        (click)="navigateToCardWallet()"
        color="secondary">
        <ion-icon
            class="dark:filter-black"
            [attr.aria-label]="'TOP_UP' | translate"
            title="{{ 'TOP_UP' | translate }}"
            src="{{ assetsPath$ | async }}/img/cards/top-up.svg"></ion-icon>
        <ion-label class="ml-2 text-base font-bold normal-case">
            {{ 'ADD_MONEY' | translate }}
        </ion-label>
    </ion-button>
</ng-template>

<ng-template #cardBalance>
    <ion-label class="text-xl font-bold" *ngIf="card?.balance || card?.balance === 0">
        {{ card?.balance | moneyFormat }}&nbsp;{{ appStartupService.getCurrency() | translate }}
    </ion-label>
    <ion-label class="text-xl font-bold" *ngIf="card?.blocked">
        {{ 'RELATED_CARD_LIST_LABEL_CARD_BLOCKED' | translate }}
    </ion-label>
</ng-template>

<ng-template #cardDetailsButton>
    <ion-button
        class="text-secondary dark:text-contrast-yellow"
        [attr.aria-label]="'VIEW_CARD_DETAILS_ELLIPSIS' | translate"
        (click)="navigateToDetailsView()"
        fill="clear">
        <ion-label class="font-semibold normal-case tracking-normal">{{
            'VIEW_CARD_DETAILS_ELLIPSIS' | translate
        }}</ion-label>
    </ion-button>
</ng-template>

<ng-template #separator>
    <div class="my-2 border border-solid border-black/10 dark:border-contrast-yellow md:my-4"></div>
</ng-template>

<ion-modal
    class="mobile-contextual-menu-modal items-end"
    #contextualMobile
    [trigger]="'mobile-contextual-menu-button-' + card?.id"
    [style.padding-bottom]="env.IS_MOBILE_APP ? '4rem' : '2rem'">
    <ng-template>
        <rwidget-card-contextual-menu
            [card]="card"
            (click)="contextualMobile.dismiss()"
            (goToPurchaseFlow)="navigateToPurchaseFlow(contextualMobile)"
            (addMoneyClick)="navigateToCardWallet(contextualMobile)"
            (blockClick)="openBlockModal(blockCardModal, contextualMobile)"
            (unBlockClick)="unblockCard(contextualMobile)"
            (removeClick)="openRemoveModal(removeCardModal, contextualMobile)"
            (editDataClick)="navigateToEditView(contextualMobile)"
            mode="dialog"></rwidget-card-contextual-menu>
    </ng-template>
</ion-modal>

<ion-popover #contextualDesktop [trigger]="'desktop-contextual-menu-button-' + card?.id" side="bottom" alignment="end">
    <ng-template>
        <ion-content class="ion-padding">
            <rwidget-card-contextual-menu
                [card]="card"
                (click)="contextualDesktop.dismiss()"
                (goToPurchaseFlow)="navigateToPurchaseFlow(contextualDesktop)"
                (addMoneyClick)="navigateToCardWallet(contextualDesktop)"
                (blockClick)="openBlockModal(blockCardModal, contextualDesktop)"
                (unBlockClick)="unblockCard(contextualDesktop)"
                (removeClick)="openRemoveModal(removeCardModal, contextualDesktop)"
                (editDataClick)="navigateToEditView(contextualDesktop)"
                mode="dialog"></rwidget-card-contextual-menu>
        </ion-content>
    </ng-template>
</ion-popover>

<rwidget-card-block-modal #blockCardModal></rwidget-card-block-modal>
<rwidget-card-remove-modal #removeCardModal></rwidget-card-remove-modal>
